import Content from './content';
import Sidebar from './sidebar';
import Main from './main';
import Box from './box';
import BoxHeader from './box-header';
import Input from './input';

export default {
    Content,
    Sidebar,
    Main,
    Box,
    BoxHeader,
    Input
};
